import React, { useState, useEffect } from "react";
import "../style/sidebar.css";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import StoreIcon from "@mui/icons-material/Store";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LocalMallIcon from '@mui/icons-material/LocalMall';
import HelpIcon from "@mui/icons-material/Help";
import { Avatar } from "@mui/material";
import { deepPurple } from '@mui/material/colors';
import axiosInstance from '../axios_helper/axiosInstance';

export default function Sidebar() {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState('');

  useEffect(() => {
    const path = location.pathname;

    if (path.startsWith('/categories/')) {
      const categoryName = path.split('/categories/')[1];

      // Fetch the category's shop information from your backend or determine it based on the category name.
      axiosInstance.get(`/categories/${categoryName}`)
        .then(response => {
          const categoryData = response.data;
          if (categoryData.shop === 1) {
            setActiveItem('MJ-Category');
          } else if (categoryData.shop === 2) {
            setActiveItem('RMJ-Category');
          }
        })
        .catch(error => {
          console.error('Failed to fetch category data:', error);
        });
    } else if (path.startsWith('/mj-shopcategory')) {
      setActiveItem('MJ-Category');
    } else if (path.startsWith('/rmj-shopcategory')) {
      setActiveItem('RMJ-Category');
    } else if (path === '/dashboard') {
      setActiveItem('dashboard');
    } else if (path === '/mj-shop') {
      setActiveItem('MJ-ShopAll');
    } else if (path === '/rmj-shop') {
      setActiveItem('RMJ-ShopAll');
    } else if (path === '/logout') {
      setActiveItem('logout');
    }
  }, [location.pathname]);

  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axiosInstance.post('logout/');
      localStorage.removeItem('token');
      navigate('/login-mdash');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="sidebar">
      <div className="top">
        <Avatar sx={{ bgcolor: deepPurple[200] }}>M</Avatar>
        <Link to="/" style={{ textDecoration: "none" }}>
          <span className="logo">Mahaveer <span className="logo">Jawellers</span></span>
        </Link>
      </div>
      <hr />
      <div className="center">
        <ul>
          <Link to="/dashboard" style={{ textDecoration: "none" }}>
            <li className={activeItem === 'dashboard' ? 'active' : ''}>
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </li>
          </Link>
          <Link to="/mj-shopcategory" style={{ textDecoration: "none" }}>
            <li className={activeItem === 'MJ-Category' ? 'active' : ''}>
              <StoreIcon className="icon" />
              <span>MJ-Category</span>
            </li>
          </Link>
          <Link to="/rmj-shopcategory" style={{ textDecoration: "none" }}>
            <li className={activeItem === 'RMJ-Category' ? 'active' : ''}>
              <StoreIcon className="icon" />
              <span>RMJ-Category</span>
            </li>
          </Link>
          <Link to="/mj-shop" style={{ textDecoration: "none" }}>
            <li className={activeItem === 'MJ-ShopAll' ? 'active' : ''}>
              <LocalMallIcon className="icon" />
              <span>MJ-ShopAll</span>
            </li>
          </Link>
          <Link to="/rmj-shop" style={{ textDecoration: "none" }}>
            <li className={activeItem === 'RMJ-ShopAll' ? 'active' : ''}>
              <LocalMallIcon className="icon" />
              <span>RMJ-ShopAll</span>
            </li>
          </Link>
          <div className="mid-center">
            <li>
              <SettingsApplicationsIcon className="icon" />
              <span>Settings</span>
            </li>
            <li>
              <AccountCircleOutlinedIcon className="icon" />
              <span>Profile</span>
            </li>
          </div>
          <div className="bottom">
            <li 
              onClick={() => {
                handleLogout();
                setActiveItem('logout');
              }} 
              className={activeItem === 'logout' ? 'active' : ''}
            >
              <ExitToAppIcon className="icon" />
              <span>Logout</span>
            </li>
            <li>
              <HelpIcon className="icon" />
              <span>Help</span>
            </li>
          </div>
        </ul>
      </div>
    </div>
  );
}
